<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Sim" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-if="!row.item.fisso" v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Sim" @click="onDelete(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                            <!-- {{ row.item.id }} -->
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <configurazione-device-sim-modal-edit-component ref="simModal" @afterSave="onAfterSaveModal" />
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioneDeviceSimModalEditComponent from "./ConfigurazioneDeviceSimModalEditComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { ConfigurazioneDeviceSimModalEditComponent },
    data() {
        return {
            filtroConfigurazioneSim: {},
            pathResource: "/devicesim",
            showModalLoading: false,
            show: true,
            perPage: 50,
            currentPage: 1,
            allItems: [],
            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Tipo", key: "tipo", sortable: true },
                { label: "Gestore", key: "gestore", sortable: true },
                { label: "Iccid", key: "iccid", thStyle: "width: 15rem" },
                { label: "Numero", key: "numero", sortable: true },
                {
                    label: "Stato attuale",
                    key: "statoAttuale",
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroConfigurazioneSim = sessionStorage.getItem("filtroConfigurazioneSim");
            if (filtroConfigurazioneSim) {
                me.filtroConfigurazioneSim = JSON.parse(filtroConfigurazioneSim);
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroConfigurazioneSim, me.loadDataSimSuccess, me.loadDataSimError);
        },
        loadDataSimSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataSimError(error) {
            let me = this;
            console.log("Errore nel caricamento delle Sim:", error);
            me.$emit("afterLoadData");
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onEdit(item) {
            this.$refs.simModal.show(item);
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare questa sim: " + item.tipo, {
                    title: "Conferma eliminazione",
                    size: "sm",
                    okVariant: "danger",
                    okTitle: "Elimina",
                    cancelTitle: "Annulla",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteSim(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteSim(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, me.deleteSimSuccess, me.deleteSimError);
        },
        deleteSimSuccess() {
            let me = this;
            me.$bvModal.msgBoxOk("Sim eliminata con successo.", {
                title: "Eliminazione completata",
                size: "sm",
                okVariant: "success",
                centered: true,
            });
            me.loadData();
        },
        deleteSimError() {
            let me = this;
            me.$bvModal.msgBoxOk("Errore durante l'eliminazione della sim.", {
                title: "Errore",
                size: "sm",
                okVariant: "danger",
                centered: true,
            });
        },
        onAfterSaveModal() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
